export default __webpack_public_path__ + "static/media/Advanced Potion Making - Spells_08.a8fed3ba.jpg";